<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <el-form :model="videoForm" :rules="rules" ref="videoForm" label-width="100px" class="demo-noticeForm">
        <el-form-item label="视频标题：" prop="title">
          <el-input v-model="videoForm.title" placeholder="请输入文章名称"></el-input>
        </el-form-item>

        <el-form-item label="视频分类：" prop="mold">
          <el-select v-model="videoForm.mold" multiple placeholder="请选择视频分类(可多选)" style="width: 100%">
            <el-option
              v-for="item in moldList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频封面：">
          <div >
            <el-upload
              class="avatar-uploader"
              ref="upload"
              accept="image/*"
              :action="upUrl + '/Index/Other/upload'"
              :name="'image'"
              :data="fileData"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
            >
              <el-image
                class="avatar"
                v-if="videoForm.imageUrl"
                :src="videoForm.imageUrl"
                fit="contain"></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>

        </el-form-item>
        <el-form-item label="视频上传：" prop="content">
          <el-upload
            :action="domain"
            :data="QiniuData"
            :on-error="uploadError"
            :on-progress="uploadVideoProcess"
            :on-success="uploadSuccess"
            :on-preview="handlePreview"
            :on-exceed="handleExceed"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            :file-list="fileList">
            <el-button type="primary">上传视频</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm('videoForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import {articleVideoDetail, questionCateList, updateArticleVideo} from "@/api/study";
import {getDate, GetExtensionFileName, getQnyToken} from "@/utils/utils";
import {ONLINEHOST, QAHOST} from "@/config";

export default {
  name: "video-edit",
  data() {
    return {
      id: '',
      moldList: [],
      fileList: [],
      upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
      videoForm: {
        title: '',
        mold: [],
        imageUrl:'',
        content: '',
      },
      rules: {
        title: [{required: true, message: '请输入文章标题', trigger: 'blur'},],
        mold: [{type: 'array', required: true, message: '请至少选择一个文章分类', trigger: 'change'},],
        content: [{required: true, message: '请上传视频', trigger: 'change'},],

      },

      QiniuData: {
        fname: '', //  文件名
        key: "", //文件名字处理
        token: "" //七牛云token
      },
      domain: "http://upload-z1.qiniup.com/", // 七牛云的上传地址（华南区）
      qiniuaddr: "http://files.yhyjy.org.cn", // 七牛云的图片外链地址 你的七牛云里配置有

    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    fileData() {
      return {
        token: this.user.token,
        addWatermark: 0
      };
    },
  },
  created() {
    this.$emit("setIndex", '/home/video-list', "双暖为老 / 视频编辑", true);
    this.QiniuData.token = getQnyToken()
    this.getList()
    if (Number(this.$route.params.id)) this.id = this.$route.params.id, this.getDetail()
  },
  components: {},
  methods: {
    //  获取列表
    async getDetail() {
      const res = await articleVideoDetail(this.$route.params.id)
      this.videoForm = {
        title: res.data.title,
        mold: res.data.cate_ids.split(',').map(Number),
        content: res.data.video_url,
        imageUrl: res.data.image,
      }
      let _name = res.data.video_url.split('/')
      this.fileList = [
        {
          name:_name[_name.length-1],
          url:res.data.video_url,
        }
      ]
    },
    //  获取列表
    async getList() {
      const res = await questionCateList('', 1, 1000)
      this.moldList = res.data
    },
    //  提交视频
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitQuestion()
        }
      });
    },
    async submitQuestion() {
      let _state = await updateArticleVideo(
        this.videoForm.title,
        this.videoForm.mold.join(','),
        this.videoForm.title,
        '',
        this.videoForm.imageUrl,
        this.videoForm.content,
        2,
        this.id
      )
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
    //  上传成功
    handleAvatarSuccess(res, file) {
      if (res.status === 200) {
        this.videoForm.imageUrl = this.upUrl + '/' + res.data
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
    //  上传前判断
    beforeAvatarUpload(file) {
      let _type = GetExtensionFileName(file.name)
      console.log(_type)
      if (_type !== 'mp4') {
        this.$message.error('请上传mp4格式的视频文件')
        return false
      }
      let _nowTime = getDate()
      //这里的key给加上了时间戳，目的是为了防止上传冲突
      this.QiniuData.fname = file.name;
      this.QiniuData.key = `zc_sn/${_nowTime}-${file.name}`;
      this.loading = this.$loading({
        lock: true,
        text: '上传中，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    //  上传中
    uploadVideoProcess(event, file, fileList) {
      this.loading.text = '已上传' + file.percentage.toFixed(0) + '%'
    },
    //  上传成功
    uploadSuccess(response, file, fileList) {
      this.videoForm.content = `${this.qiniuaddr}/${response.key}`;
      this.loading.close()
    },
    //  上传失败
    uploadError(err, file, fileList) {
      this.loading.close();
      this.$message({
        message: "上传出错，请重试！",
        type: "error",
        center: true
      });
    },
    handlePreview() {
      window.open(this.videoForm.content, '_blank')
    },
    handleExceed() {
      this.$message.error('请删除之前上传的文件')
    },

  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  display: block;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 180px;
  display: block;
  border: 1px dashed #d9d9d9;
  &.active{
    width: 400px;
    height: 300px;
  }
}
</style>
